import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Checkbox,
  Alert,
  Tooltip
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import "../../../style/subAdmin/SubAdmin.scss";
import isEmpty from "lodash.isempty";
import { getDealList } from "../../../redux/actions/dealActions";
import {
  add_voucher,
  getdealForVoucher,
  checkEmail,
  checkQuantity,
  renderAutoEmail
} from "../../../redux/actions/voucherActions";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import loader from "../../../style/loader/loader.scss";
import ReactAutocomplete from "react-autocomplete";
import {aclUtil} from "../../util"
import Picky from "react-picky";
import "react-picky/dist/picky.css";

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

let isLoading = "false",
  list = [];

class GenerateVoucher extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'GENERATE_VOUCHER',
      voucherID: "",
      quantity: "",
      status: "Active",
      path: ["Home", "Manage Vouchers List", "Generate Voucher"],
      links:['home', 'voucherList', 'generateVoucher'],
      alertMessage: "",
      show: false,
      disabled: false,
      selectedSites: [],
      dealListData: [],
      offersList: [],
      voucherType: "direct",
      query: "",
      results: [],
      single: null,
      selectedOption: null,
      dealID: "",
      userEmail: "",
      filteredList: "",
      emailMessage: "",
      emailData: [],
      qtyMessage: "",
      value: "",
      qtyLimit: "",
      qtyMessageError: ""
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validate = this.validate.bind(this);
    this.Clear = this.Clear.bind(this);
    this.handleSiteChange = this.handleSiteChange.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  validate = () => {
    let isError = false;
    const errors = {};

    if (this.state.dealID.length === 0) {
      isError = true;
      this.setState({ dealIDError: "red" });
    }
    
    if (this.state.quantity == '0') {
      isError = true;
      this.setState({ quantityError: "red" });
    }

    if (this.state.quantity.length === 0) {
      isError = true;

      this.setState({ quantityError: "red" });
    } else if (this.state.quantity && this.state.qtyMessageError !== "") {
      isError = true;
      this.setState({ quantityError: "red" });
    }

    if (this.state.userEmail.length === 0) {
      isError = true;

      this.setState({ userEmailError: "red" });
    }

    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();

    if (!err) {
      this.setState({ disabled: true });
      this.handleDismiss();
      this.handleShow();
      const postData = {
        voucherType: this.state.voucherType,
        dealID: this.state.dealID,
        quantity: this.state.quantity,
        status: this.state.status,
        email: this.state.value
      };
      this.props.add_voucher(postData);
    }
  }

  handleChange(e) {
    this.handleDismiss();
    this.props.clearAlert();
    this.setState({ qtyMessageError: "" });
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });

    let postaData = {
      dealID: e.target.value
    };
    this.props.checkQuantity(postaData);
    isLoading = "true";
    this.setState({ disabled: false });
  }

  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }
    if (this.props.offerslist !== nextProps.offerslist) {
      console.log(nextProps.offerslist);
      if (nextProps.offerslist) {
        if (nextProps.offerslist.data) {
          isLoading = "false";
        }
        this.setState({ offersList: nextProps.offerslist.data });
      }
    }

    if (this.props.voucherResponse !== nextProps.voucherResponse) {
      if (nextProps.voucherResponse) {
        this.props.clearAlert();

        this.handleShow();
        this.props.renderAlert("success", nextProps.voucherResponse.message);
        this.setState({ disabled: false });
        isLoading = "false";
        this.Clear();
      }
    }

    if (this.props.emailResponse !== nextProps.emailResponse) {
      if (nextProps.emailResponse) {
        this.setState({ emailMessage: nextProps.emailResponse.message });
      }
    }

    if (this.props.autoEmailData !== nextProps.autoEmailData) {
      if (nextProps.autoEmailData) {
        this.setState({ emailData: nextProps.autoEmailData.data });
      }
    }

    if (this.props.checkQty !== nextProps.checkQty) {
      if (nextProps.checkQty) {
        this.props.clearAlert();
        this.handleDismiss();
        this.setState({ qtyLimit: nextProps.checkQty.data });
        isLoading = "false";
        this.setState({ disabled: false });
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        isLoading = "false";
        this.props.clearAlert();
        this.props.renderAlert("warning", nextProps.error);
      }
    }
  }

  Clear() {
    this.state.dealID = "";
    (this.state.quantity = ""),
      (this.state.status = "Active"),
      (this.state.qtyMessage = ""),
      (this.state.value = ""),
      (this.state.alertMessage = ""),
      (this.state.qtyLimit = ""),
      this.handleDismiss();
  }

  componentWillMount() {
    this.handleDismiss();
    this.props.clearAlert();
    isLoading = "true";
    this.props.getdealForVoucher();
  }
  componentWillUnmount() {
    this.props.clearAlert();
  }

  onChangeEmail(e) {
    this.handleDismiss();
    this.setState({ value: e.target.value });
    this.setState({ userEmail: e.target.value });
    this.setState({ emailMessage: "" });
    if (this.state.userEmailError !== "") {
      this.setState({ userEmailError: "" });
    }
    let email = { email: e.target.value };
    this.props.renderAutoEmail(email);
    this.setState({ disabled: false });
  }

  onChangeQty(e) {
    this.handleDismiss();
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });

    this.setState({ disabled: false });
    this.setState({ qtyMessageError: "" });
  }

  onQtyBlur = e => {
    e.preventDefault();
    let qty = this.state.quantity;
    let qtylimit = this.state.qtyLimit;
    if (qty > qtylimit && qtylimit !== '') {
      this.setState({
        qtyMessageError: "Quantity can be up to" + this.state.qtyLimit + "!"
      });
    }

  };
  handleSiteChange(event, data) {
    console.log(event.dealID);
    this.setState({
      selectedSites: event,
      dealID:event.dealID
    });
  }

  onUserEmailBlur = field => e => {
    this.props.checkEmail(this.state.value);
  };

  render() {
     const {selectedSites } = this.state;
    let offerData = this.state.offersList ? this.state.offersList : [];

    let offerslist = [];
    if (offerData) {
      offerslist = offerData.map((el, idx) => (
        <option key={el.dealID} value={el.dealID}>
          {el.dealText + ' (' + el.merchantName + ')'}
        </option>
      ));
    }
    let emailList = this.state.emailData ? this.state.emailData : [];

    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <form onSubmit={this.handleSubmit}>
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Generate Vouchers</header>
            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formOffer">
                      <ControlLabel>
                        {" "}
                        <span style={{ color: "red" }}>*</span> Select Offer
                      </ControlLabel>
                         <Picky
                  numberDisplayed={3}
                  options={offerData}
              
                   onChange={this.handleSiteChange}
                    includeFilter
                   valueKey="dealID"
                  labelKey="dealText"
                  value={this.state.selectedSites}
                  dropdownHeight={200}
                />
                      {/*<FormControl
                        componentClass="select"
                        name="dealID"
                        style={{ borderColor: this.state.dealIDError }}
                        onChange={this.handleChange}
                        value={this.state.dealID}
                      >
                        <option value="select">Select </option>
                        {offerslist}
                      </FormControl>*/}
                    </FormGroup>
                    {this.state.qtyMessageError && (
                      <Tooltip
                        placement="bottom"
                        className="in"
                        id="tooltip-bottom"
                      >
                        {this.state.qtyMessageError}
                      </Tooltip>
                    )}
                    <FormGroup controlId="formDiscountAmount">
                      <ControlLabel>
                        {" "}
                        <span style={{ color: "red" }}>*</span> Quantity (can be
                        up to {this.state.qtyLimit})
                      </ControlLabel>
                      <FormControl
                        className="halfWidth"
                        type="number"
                        value={this.state.quantity}
                        placeholder="Quantity"
                        onChange={this.onChangeQty.bind(this)}
                        onBlur={this.onQtyBlur.bind(this)}
                        name="quantity"
                        style={{ borderColor: this.state.quantityError }}
                      />
                    </FormGroup>

                    <FormGroup controlId="formStatus">
                      <ControlLabel>User</ControlLabel>

                      <br />
                      <ReactAutocomplete
                        inputProps={{
                          style: {
                            borderColor: this.state.userEmailError,
                            width: "248%",
                            height: "34px",
                            display: "block",
                            padding: "6px 12px",
                            border: "1px solid #ccc"
                          }
                        }}
                        items={emailList}
                        shouldItemRender={(item, value) =>
                          item.email
                            .toLowerCase()
                            .indexOf(value.toLowerCase()) > -1
                        }
                        getItemValue={item => item.email}
                        renderItem={(item, highlighted) => (
                          <div
                            className="form-group"
                            key={item.id}
                            style={{
                              backgroundColor: highlighted
                                ? "#eee"
                                : "transparent"
                            }}
                          >
                            {item.email}
                          </div>
                        )}
                        value={this.state.value}
                        onChange={this.onChangeEmail.bind(this)}
                        onSelect={value => this.setState({ value })}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          <Row className="BtnRow">
            <Col md={12} xs={12}>
              <Button
                bsStyle="info"
                type="submit"
                id="saveButton"
                disabled={this.state.disabled}
              >
                Save{" "}
              </Button>
              <Button
                bsStyle="default"
                onClick={() => this.context.router.history.push(`/voucherList`)}
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    dealList: state.dealReducer.dealList,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    voucherResponse: state.voucherReducer.voucherResponse,
    offerslist: state.voucherReducer.offerslist,
    error: state.voucherReducer.error,
    emailResponse: state.voucherReducer.emailResponse,
    autoEmailData: state.voucherReducer.autoEmailData,
    checkQty: state.voucherReducer.checkQty
  };
};

export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    getDealList,
    renderAlert,
    clearAlert,
    add_voucher,
    checkQuantity,
    getdealForVoucher,
    checkEmail,
    renderAutoEmail
  })
)(GenerateVoucher);



// WEBPACK FOOTER //
// ./src/app/views/admin/voucher/GenerateVoucher.js